const SignoutRedirectPage = () => {
    console.log("RELOADING")
  window.location.reload(true);
  window.location.replace("/");
}

export default SignoutRedirectPage